



























































































































import { Component, Vue, Watch } from "@/shared/node_modules/vue-property-decorator";
import { CrudService } from "@/shared/core/services/crudService";
import { Settings } from "@/shared/core/services/configService";
import store from "@/shared/core/store";

@Component
export default class CoursePage extends Vue {
  course: any = null;
  hasAccess: boolean = false;
  sections: any[] = [];
  progress: any[] = [];
  totalLessons: number = 0;
  completedLessons: number = 0;
  percentComplete: number = 0;
  allCourses: any[] = [];
  enrolledCourses: any[] = [];
  uploadsUrl: string = "";

  get customerId(): number {
    try {
      const raw = localStorage.getItem(window.location.host + "_cc");
      if (raw) { const p = JSON.parse(raw); const v = p.value || p; return (typeof v === "string" ? JSON.parse(v) : v).id; }
    } catch (e) {}
    return 0;
  }

  get currentLesson(): any {
    const all = this.sections.flatMap((s: any) => s.lessons);
    for (const l of all) { if (this.getStatus(l.id) !== 2) return l; }
    return null;
  }

  get totalDurationSec(): number {
    return this.sections.flatMap((s: any) => s.lessons).reduce((t: number, l: any) => t + (l.durationSeconds || 0), 0);
  }

  get switcherCourses(): any[] {
    const others = this.allCourses.filter((c: any) => c.id !== this.course?.id);
    return [this.course, ...others].filter(Boolean).slice(0, 2);
  }

  get otherCourses(): any[] {
    return this.allCourses.filter((c: any) => c.id !== this.course?.id);
  }

  get thumbBg(): any {
    const url = this.course?.poster;
    if (!url) return {};
    const src = url.startsWith("http") ? url : this.uploadsUrl + "/" + url;
    return { backgroundImage: `linear-gradient(0deg, rgba(0,0,0,.5), transparent 50%), url(${src})` };
  }

  async mounted() {
    this.uploadsUrl = store.state.settings?.Uploads || "";
    await this.loadAll();
    await this.loadCourse(this.$route.params.id);
  }

  @Watch("$route.params.id")
  async onRouteChange(id: string) { await this.loadCourse(id); }

  async loadAll() {
    const crud = new CrudService();
    const [allRes, myRes] = await Promise.all([
      crud.httpGet(`${Settings.HostName}/api/public-courses/list`),
      this.customerId
        ? crud.httpGet(`${Settings.HostName}/api/public-courses/my-courses?customerId=${this.customerId}`)
        : Promise.resolve(null)
    ]);
    this.allCourses = allRes?.data || [];
    this.enrolledCourses = myRes?.data || [];
  }

  async loadCourse(courseId: string) {
    const data = await new CrudService().httpGet(
      `${Settings.HostName}/api/public-courses/${courseId}?customerId=${this.customerId || 0}`
    );
    if (!data?.ok) return;
    this.course = data.course;
    this.hasAccess = data.hasAccess;
    this.sections = data.sections;
    this.progress = data.progress || [];
    this.totalLessons = data.totalLessons;
    this.completedLessons = data.completedLessons;
    this.percentComplete = data.percentComplete;
    window.scrollTo(0, 0);
  }

  switchCourse(id: number) {
    this.$router.push(`/courses/${id}`);
  }

  getStatus(lessonId: number): number {
    const p = this.progress.find((x: any) => x.courseLessonId === lessonId);
    return p ? p.status : 0;
  }

  isCurrentLesson(id: number): boolean {
    return this.currentLesson?.id === id;
  }

  isLocked(lesson: any): boolean {
    if (!this.course?.sequentialMode) return false;
    const all = this.sections.flatMap((s: any) => s.lessons);
    const idx = all.findIndex((l: any) => l.id === lesson.id);
    if (idx <= 0) return false;
    return this.getStatus(all[idx - 1].id) !== 2;
  }

  onLessonClick(lesson: any) {
    if (!this.hasAccess || this.isLocked(lesson)) return;
    this.$router.push(`/courses/${this.course.id}/lessons/${lesson.id}`);
  }

  goToCurrentLesson() {
    if (this.currentLesson) this.onLessonClick(this.currentLesson);
  }

  pUrl(c: any): string {
    if (!c.poster) return "";
    return c.poster.startsWith("http") ? c.poster : this.uploadsUrl + "/" + c.poster;
  }

  formatDuration(s: number): string { return s ? Math.round(s / 60) + " min" : "0 min"; }
  fmtTime(s: number): string { const m = Math.floor(s / 60); const sec = s % 60; return m + ":" + (sec < 10 ? "0" : "") + sec; }
}
